export default __webpack_public_path__ + "img/main.purple.3ec154b2.png";